import type { Profile } from "@/contexts/AuthContext";

/**
 * True when the user has a non-free plan whose paid period hasn't ended yet.
 *
 * Mirrors the server `subscriberOnly` gate — deliberately admits
 * cancelled-but-not-yet-expired payers (after the wind-down bulk-cancel they
 * are status="cancelled" but keep access until current_period_end).
 */
export function isActivePaidSubscriber(profile: Profile | null): boolean {
  if (!profile?.subscription_name || profile.subscription_name === "free") return false;
  if (!profile.current_period_end) return false;
  return new Date(profile.current_period_end) > new Date();
}

/**
 * Whether a user may take action (generate) during the controlled wind-down.
 * Admins keep access for testing; everyone else must be an active paid
 * subscriber. Matches the server-side gate in subscriberOnly.ts.
 */
export function canUseDuringWindDown(profile: Profile | null): boolean {
  if (profile?.role === "admin") return true;
  return isActivePaidSubscriber(profile);
}
